// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__22Rqd","item":"PaymentsMobile_item__VvkUZ","label":"PaymentsMobile_label__lJv2A","amount":"PaymentsMobile_amount__175ce"};